export default __webpack_public_path__ + "static/media/charles-testi.0e0b9cbd.jpg";